(function() {
  // ===== TEMPORARY DIAGNOSTIC (remove after debugging) =====
  // Logs every time a header submenu closes, with a stack trace showing which
  // code path did it. Watch the console, open a dropdown, and note the trace
  // printed the instant it closes.
  function installCloseTracer() {
    var headers = document.querySelectorAll("sht-menu-header details");
    if (!headers.length) { return setTimeout(installCloseTracer, 200); }
    headers.forEach(function(details) {
      var wasOpen = details.classList.contains("is-open") || details.hasAttribute("open");
      new MutationObserver(function() {
        var isOpen = details.classList.contains("is-open") || details.hasAttribute("open");
        if (wasOpen && !isOpen) {
          console.log("[menu-debug] submenu CLOSED  level=" + details.dataset.level, details);
          console.trace("[menu-debug] close stack");
        }
        if (!wasOpen && isOpen) {
          console.log("[menu-debug] submenu OPENED  level=" + details.dataset.level);
        }
        wasOpen = isOpen;
      }).observe(details, { attributes: true, attributeFilter: ["class", "open"] });
    });
    console.log("[menu-debug] close tracer installed on " + headers.length + " details");
  }
  installCloseTracer();
  // ===== END TEMPORARY DIAGNOSTIC =====

  // Patch SHTMenuHeader to fix submenu visibility issues
  var origDefine = customElements.define;
  var patched = false;

  // Wait for SHTMenuHeader to be defined, then patch its prototype
  function patchMenuHeader() {
    if (patched) return;
    var MenuHeaderClass = customElements.get('sht-menu-header');
    if (!MenuHeaderClass) return;
    patched = true;

    var proto = MenuHeaderClass.prototype;

    // Fix 1: Store bound handleBodyClick reference so removeEventListener works
    var origOpen = proto.open;
    var origClose = proto.close;

    proto.open = function() {
      if (!this._boundHandleBodyClick) {
        this._boundHandleBodyClick = this.handleBodyClick.bind(this);
      }
      document.body.removeEventListener("click", this._boundHandleBodyClick);
      document.body.addEventListener("click", this._boundHandleBodyClick);
    };

    proto.close = function() {
      if (this._boundHandleBodyClick) {
        document.body.removeEventListener("click", this._boundHandleBodyClick);
      }
      document.body.classList.remove("is-megamenu-show");

      if ("1" == this.details.dataset.level && this.details.hasAttribute("open")) {
        this.header && this.header.classList.remove("header-menu--open");
        this.menu_body_drawer && this.menu_body_drawer.classList.remove("menu--is-open");
      }

      for (var s = 0; s < this.summaries.length; s++) {
        var summary = this.summaries[s];
        var details = summary.closest("details");
        var wrapper = details.querySelector(".js-header-menu-wrapper");
        if (wrapper) {
          wrapper.classList.remove("animated");
          wrapper.classList.add("animated-out");
          setTimeout(function(w) {
            return function() { w.classList.remove("animated-out"); };
          }(wrapper), 300);
        }
        details.classList.remove("is-open");
        setTimeout(function(d, sum) {
          return function() {
            d.removeAttribute("open");
            sum.setAttribute("aria-expanded", false);
          };
        }(details, summary), 100);
      }
    };

    // Fix 2: Add scroll threshold so micro-scrolls don't close menus
    var origHandleScrollEvent = proto.handleScrollEvent;

    proto.handleScrollEvent = function() {
      var self = this;
      var lastScrollY = window.scrollY;
      var scrollThreshold = 30;
      var ticking = false;

      if (this.scrollHandler) {
        window.removeEventListener("scroll", this.scrollHandler);
      }

      this.scrollHandler = function() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function() {
          var scrollDelta = Math.abs(window.scrollY - lastScrollY);
          if (scrollDelta > scrollThreshold) {
            lastScrollY = window.scrollY;
            document.body.classList.remove("is-megamenu-show");
            self.$$("details[open]").forEach(function(detail) {
              var wrapper = detail.querySelector(".js-header-menu-wrapper");
              var summary = detail.querySelector("summary");
              if (wrapper) {
                wrapper.classList.remove("animated");
                wrapper.classList.add("animated-out");
                setTimeout(function() {
                  wrapper.classList.remove("animated-out");
                  detail.classList.remove("is-open");
                  detail.open = false;
                  if (summary) summary.setAttribute("aria-expanded", false);
                }, 300);
              }
            });
            if (self.closeTimeout) {
              clearTimeout(self.closeTimeout);
              self.closeTimeout = null;
            }
          }
          ticking = false;
        });
      };
      window.addEventListener("scroll", this.scrollHandler, { passive: true });
    };

    // Fix 3: The patched handleScrollEvent above only runs from connectedCallback,
    // which already fired during theme.js (loaded before this file). Without this,
    // the ORIGINAL no-threshold scroll listener stays attached and closes any
    // just-opened dropdown on the slightest (e.g. trackpad) scroll. Re-invoke it on
    // each already-connected instance so its own cleanup swaps the old listener for
    // the threshold-aware one. Instances that connect later get it via the prototype.
    document.querySelectorAll("sht-menu-header").forEach(function(el) {
      if (typeof el.handleScrollEvent === "function") {
        el.handleScrollEvent();
      }
    });
  }

  // Try patching after custom element is defined
  if (customElements.get('sht-menu-header')) {
    patchMenuHeader();
  } else {
    customElements.whenDefined('sht-menu-header').then(patchMenuHeader);
  }
})();
